import { Api } from '@axiom/ui';
import type { MfaPhoneNumber, MfaVerification, User } from '@axiom/validation';

import { EnvUtil } from '../utils/env-util';

class UsersApiClass extends Api {
  constructor() {
    super({
      domain: EnvUtil.apiPortalUrl,
    });
  }

  async updateMfaPhoneNumber(userId: string, body: MfaPhoneNumber) {
    return super.write<{ data: MfaPhoneNumber }>({
      endpoint: `/users/${userId}/notificationsPhoneNumber`,
      method: 'PUT',
      body,
    });
  }

  async createMfaVerification(userId: string, body: MfaVerification) {
    return super.write<{ data: string }>({
      endpoint: `/users/${userId}/notificationsPhoneNumberValidate`,
      method: 'POST',
      body,
    });
  }

  async updateUser(user: User) {
    return super.write<{ data: User }>({
      endpoint: `/users/${user.id}`,
      method: 'PATCH',
      body: user,
    });
  }
}

export const UsersApi = new UsersApiClass();
